<script setup>
import { Link, useForm } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import HotelSubMenu from '@/Includes/HotelSubMenu.vue';
import Swal from 'sweetalert2';
import { useToast } from 'vue-toast-notification';
import MealEditModal from "@/Pages/Mealtypes/editModal.vue";
import Loading from 'vue-loading-overlay';
import { ref, onMounted } from "vue";
import { Modal } from 'bootstrap';

const props = defineProps({
    year: String,
    mealTypes: Object,
    hotelsById: Object,
    flash: Object,
    card: Boolean,
    mealtype: Object,
    user: Object,
});

const $toast = useToast();
let isLoading = ref(false);
let modalShow = ref(null);
let thisModalObj = null;
let menu = 'mealtypes';

onMounted(() => {
    thisModalObj = new Modal(modalShow.value);
});

const MealsAddform = useForm({
    name: null,
    adult_rate: 0,
    child_rate: 0,
    infant_rate: 0,
    hotel_id: props.hotelsById.id,
});

const MealsAddformSubmit = () => {

    MealsAddform.post('/mealtypes/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide(),

                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                });
        }
    });
};

function deleteMealType(value) {
    new Swal({
        title: 'Are you sure?',
        text: "All the data related to this object will be deleted!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure!'
    }).then((result) => {
        if (result.isConfirmed) {
            setTimeout(() => {
                window.location.href = '/mealtypes/delete/' + value;
            }, 300);

            $toast.success('Meal type deleted successfully!', {
                position: 'top-right',
                duration: 4000,
                hideProgressBar: true,
                icon: true,
                type: "info",
                class: 'bs-toast toast bg-dark show'
            });
        }
    })
}

const FormReset = () => {
    MealsAddform.reset();
    MealsAddform.clearErrors();
};

</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import "vue-loading-overlay/dist/vue-loading.css";
@import "sweetalert2/dist/sweetalert2.min.css";
</style>
<template>
    <AppLayout title="Hotel Meal Types" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <HotelSubMenu :hotelsById="hotelsById" :menu="menu" />
            <div class="row g-0">
                <div class="card">
                    <h5 class="card-header">Available Meal Types</h5>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mt-5 mt-md-0">
                                <div class="added-cards">
                                    <div class="cardMaster bg-lighter rounded-2 p-3 mb-3"
                                        v-for="(meals, index) in mealTypes" :key="meals.id"
                                        style="border: 1px solid #8592a3;">
                                        <div class="d-flex justify-content-between flex-sm-row flex-column">
                                            <div class="card-information me-2">
                                                <img class="mb-3 img-fluid" src="/ui/img/icons/general/mealtypes.png"
                                                    alt="Meal Type" width="30">
                                                <div class="d-flex align-items-center mb-1 flex-wrap gap-2">
                                                    <h6 class="mb-0 me-2">{{ meals.name }}</h6>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column text-start text-sm-end">
                                                <div class="d-flex order-sm-0 order-1 mt-sm-0 mt-3">
                                                    <Link class="btn btn-label-primary me-2"
                                                        v-if="$page.props.user.permissions.includes('edit-mealtypes')"
                                                        :href="'/mealtypes/showEditModal/' + meals.id + '/' + hotelsById.id"
                                                        preserve-scroll replace>
                                                    Edit Meal Type
                                                    </Link>
                                                    <Link class="btn btn-label-secondary" href="#"
                                                        v-if="$page.props.user.permissions.includes('remove-mealtypes')"
                                                        @click="deleteMealType(meals.id)" preserve-scroll replace>Delete
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mt-5 mt-md-0">
                                <div class="text-center mt-4 mx-3 mx-md-0">
                                    <img src="/ui/img/illustrations/meals.jpg" class="img-fluid" alt="meals"
                                        width="450">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MealEditModal v-if="props.card" :card="props.card" :mealTypes="props.mealTypes" :flash="flash"
            :mealtype="props.mealtype" :hotelsById="props.hotelsById" />

        <div class="modal fade" id="addMealModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add Meal Type</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="MealsAddformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col mb-3">
                                    <label for="nameBasic" class="form-label">Name</label>
                                    <input type="text" v-model="MealsAddform.name" class="form-control"
                                        placeholder="Meal Type Name"
                                        :class="{ 'is-invalid': MealsAddform.errors.name }">
                                    <div v-if="MealsAddform.errors.name" class="invalid-feedback">
                                        <div v-text="MealsAddform.errors.name">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" data-bs-dismiss="modal"
                                @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Add</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>